// error-message.component.ts
import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';

@Component({
  selector: 'formly-error-message',
  template: `
    <div *ngIf="errorMessage !== null">{{ errorMessage }}</div>
  `,
})
export class FormlyWrapperErrorMessageComponent {
  @Input() field: FormlyFieldConfig;

  get errorMessage() {
    for (let error in this.field.formControl.errors) {
      if (this.field.formControl.errors.hasOwnProperty(error) && this.field.formControl.touched) {
        return this.field.validation.messages[error];
      }
    }
    return null;
  }
}
